module.exports = __webpack_public_path__ + "img/success_dialog.700c05ca.svg";